exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".module-details section{border:1px solid #e6f1f2;margin:24px 0;padding:24px;border-radius:2px}.module-details section .info:not(:last-child){margin-right:6px}.module-details section .info .label{margin-right:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ba5402f","scoped":false,"sourceMap":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modules/ModuleDetails.vue
// module id = 507
// module chunks = 0